import { Link } from "react-router-dom";
import { ShieldCheck, ArrowLeft, FileCheck2, AlertTriangle, ScrollText, FileWarning } from "lucide-react";
import Header from "../components/Header";

/**
 * Annahmebedingungen-Seite für Händler, die Privatkunden-Ankaufanfragen
 * annehmen möchten. Wird aus der Buy-Request-Acceptance-Section in den
 * Dealer-Settings verlinkt (Pflicht-Lektüre vor dem Aktivieren).
 *
 * Inhalt ist ein Konsolidierter Standard-Text für eine deutsche
 * Marketplace-Vermittlung — KEINE Rechtsberatung. Live-Deployment sollte
 * den Text durch die anwaltlich geprüfte Endfassung ersetzen; Struktur
 * + data-testids bleiben damit gleich.
 */
export default function BuyRequestTermsPage() {
    const sections = [
        {
            icon: FileCheck2,
            title: "1. Geltungsbereich",
            paragraphs: [
                "Diese Annahmebedingungen regeln die Teilnahme von Vertragshändlern und gewerblichen Anbietern (im Folgenden „Händler”) am twowheels.info-Ankaufprogramm „Wir kaufen Dein Bike”, über das Privatpersonen ihre Motorräder und Fahrräder zum Verkauf an gewerbliche Käufer einreichen.",
                "Mit dem Aktivieren der Funktion „Ankaufanfragen erhalten” im Händlerprofil bestätigt der Händler, diese Bedingungen vollständig gelesen und akzeptiert zu haben.",
            ],
        },
        {
            icon: ShieldCheck,
            title: "2. Identitätsprüfung & KYC",
            paragraphs: [
                "Voraussetzung für die Teilnahme ist ein als „verifiziert” gekennzeichnetes Händlerkonto. Die Plattform behält sich vor, Gewerbeanmeldung, Umsatzsteuer-ID, Handelsregistereintrag sowie Identitätsdokumente der Geschäftsführung anzufordern und gegen geeignete Datenbanken zu prüfen.",
                "Der Händler verpflichtet sich, Änderungen an diesen Stammdaten innerhalb von 14 Tagen im Profil zu aktualisieren. Verletzungen können zur sofortigen Sperrung des Kontos und zum Ausschluss aus dem Ankaufprogramm führen.",
            ],
        },
        {
            icon: AlertTriangle,
            title: "3. Pflichten bei der Fahrzeug-Inspektion",
            paragraphs: [
                "Vor verbindlicher Annahme eines Ankaufangebots ist der Händler verpflichtet, das Fahrzeug persönlich oder durch qualifiziertes Personal in Augenschein zu nehmen und die zentralen Merkmale (Rahmennummer, HU-Status, Kilometerstand, allgemeiner Zustand) mit den Angaben des Verkäufers abzugleichen.",
                "Abweichungen zwischen Anzeigentext und tatsächlichem Zustand dürfen nicht einseitig zulasten des Verkäufers ausgelegt werden. Findet sich eine wesentliche Diskrepanz, ist das Angebot vollständig zurückzuziehen oder schriftlich angepasst neu vorzulegen.",
                "Bilder, Sichtbefunde und Inspektionsprotokolle sind für mindestens 24 Monate revisionssicher zu archivieren.",
            ],
        },
        {
            icon: ScrollText,
            title: "4. Faire Preisbildung",
            paragraphs: [
                "Ankaufpreise sind am marktüblichen Wert zu orientieren. Eine plausible Bandbreite kann z.B. anhand von Schwacke, EurotaxAutowert oder vergleichbaren Marktdaten ermittelt werden — der Händler legt die Berechnungsbasis dem Verkäufer auf Wunsch offen.",
                "Aggressive Lowball-Strategien (systematische Angebote >25% unter Marktwert ohne sachlichen Grund) berechtigen die Plattform zur Verwarnung und nach wiederholtem Verstoß zur Sperrung des Kontos.",
                "Annahme oder Ablehnung eines abgegebenen Angebots erfolgen vollständig durch den Verkäufer; ein „Take-back” durch den Händler nach Angebotsannahme ist nur bei wesentlicher Wertminderung möglich, die bei der Inspektion nicht erkennbar war.",
            ],
        },
        {
            icon: FileWarning,
            title: "5. Datenschutz & DSGVO",
            paragraphs: [
                "Die Plattform übermittelt dem Händler ausschließlich die für die Bewertung erforderlichen Fahrzeugdaten. Kontaktdaten des Verkäufers werden erst nach Annahme eines Angebots durch den Verkäufer freigegeben.",
                "Empfangene personenbezogene Daten dürfen ausschließlich zum Zweck der konkreten Ankaufabwicklung verwendet und nicht an Dritte (z.B. zur Akquisition für Folgegeschäfte) weitergegeben werden. Nach Abschluss der Transaktion bzw. Verfall des Angebots sind die Daten zu löschen, sofern keine handels- oder steuerrechtlichen Aufbewahrungsfristen entgegenstehen.",
                "Der Händler benennt eine verantwortliche Stelle nach Art. 4 DSGVO und stellt eine Datenschutzerklärung zur Verfügung, die über den eigenen Internetauftritt erreichbar sein muss.",
            ],
        },
        {
            icon: ScrollText,
            title: "6. Übergabe & Zahlung",
            paragraphs: [
                "Die Eigentumsübertragung erfolgt mit Übergabe des Fahrzeugs sowie aller relevanten Papiere (Brief, Schein, ggf. COC). Eine Bezahlung in bar ist ab einem Betrag von 10.000 € gemäß GwG nicht gestattet; bargeldlose Zahlung (Überweisung, Bankscheck) ist verpflichtend.",
                "Der Händler dokumentiert die Übergabe schriftlich (Kaufvertrag, Identitätsabgleich, Tachostand). Der Plattform kann auf begründetes Verlangen Einsicht in diese Dokumente gewährt werden.",
            ],
        },
        {
            icon: AlertTriangle,
            title: "7. Sanktionen bei Verstößen",
            paragraphs: [
                "Bei Verstoß gegen diese Bedingungen behält sich die Plattform vor: (1) schriftliche Verwarnung, (2) befristete Sperrung der Ankaufsfunktion, (3) dauerhafte Sperrung des Händlerkontos. Die Stufen sind nicht kumulativ erforderlich — bei schwerem Verstoß (z.B. Betrugsverdacht, GwG-Verletzung) ist die sofortige dauerhafte Sperrung möglich.",
                "Eine Wiederaufnahme nach Sperrung ist nur nach schriftlicher Stellungnahme und Compliance-Review möglich.",
            ],
        },
        {
            icon: FileCheck2,
            title: "8. Schlussbestimmungen",
            paragraphs: [
                "Es gilt deutsches Recht. Erfüllungsort und ausschließlicher Gerichtsstand für alle Streitigkeiten aus diesem Programm ist der Sitz des Plattformbetreibers, sofern der Händler Kaufmann im Sinne des HGB ist.",
                "Sollten einzelne Bestimmungen unwirksam sein, bleibt die Wirksamkeit der übrigen Bestimmungen unberührt. An die Stelle einer unwirksamen Bestimmung tritt diejenige wirksame Regelung, die dem wirtschaftlich Gewollten am nächsten kommt.",
            ],
        },
    ];

    return (
        <div className="min-h-screen bg-white" data-testid="buy-request-terms-page">
            <Header />
            <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8 py-8 sm:py-12">
                <Link
                    to="/dashboard?tab=dealer"
                    className="inline-flex items-center gap-1 text-xs font-bold uppercase tracking-wider text-[#6B7280] hover:text-[#111827]"
                    data-testid="terms-back-link"
                >
                    <ArrowLeft className="w-3.5 h-3.5" /> Zurück zu den Händler-Einstellungen
                </Link>

                <div className="mt-4 mb-8">
                    <div className="inline-flex items-center gap-2 text-[10px] font-bold uppercase tracking-wider text-[#92400E] bg-[#FFFBEB] border border-[#FFCC00] px-3 py-1 rounded-sm">
                        <ShieldCheck className="w-3 h-3" /> Verbindliche Annahmebedingungen
                    </div>
                    <h1 className="text-4xl sm:text-5xl font-black text-[#111827] font-display tracking-tight mt-3">
                        Annahmebedingungen
                    </h1>
                    <p className="text-base text-[#6B7280] mt-2 leading-relaxed">
                        Für Händler, die Privatkunden-Ankaufanfragen über twowheels.info annehmen — Stand 15.05.2026, Version 1.0.
                    </p>
                </div>

                <div className="bg-[#111827] text-[#FFCC00] rounded-sm p-4 mb-8 text-xs font-bold uppercase tracking-wider flex items-start gap-2" data-testid="terms-disclaimer">
                    <AlertTriangle className="w-4 h-4 mt-0.5 flex-shrink-0" />
                    <span className="leading-relaxed normal-case font-normal text-white/80">
                        <strong className="text-[#FFCC00] uppercase tracking-wider">Demo-Vertragstext.</strong>{" "}
                        Dieser Vertrag dient als Vorlage und ist keine anwaltliche Rechtsberatung. Vor Produktiveinsatz bitte
                        durch einen Fachanwalt für Vertragsrecht prüfen lassen.
                    </span>
                </div>

                <div className="space-y-8" data-testid="terms-sections">
                    {sections.map((sec, idx) => (
                        <section key={idx} data-testid={`terms-section-${idx + 1}`}>
                            <div className="flex items-center gap-2 mb-3">
                                <sec.icon className="w-5 h-5 text-[#FFCC00]" />
                                <h2 className="text-xl font-black text-[#111827] font-display">{sec.title}</h2>
                            </div>
                            <div className="space-y-3 text-sm text-[#111827] leading-relaxed pl-7">
                                {sec.paragraphs.map((p, i) => (
                                    <p key={i}>{p}</p>
                                ))}
                            </div>
                        </section>
                    ))}
                </div>

                <div className="mt-12 border-t border-gray-200 pt-6 text-xs text-gray-500" data-testid="terms-footer">
                    Stand: 15.05.2026 · Version 1.0 · twowheels.info — Kontakt zur Compliance:{" "}
                    <a href="mailto:compliance@twowheels.info" className="text-blue-700 hover:underline">
                        compliance@twowheels.info
                    </a>
                </div>
            </div>
        </div>
    );
}
